import * as React from 'react';

export default () => <div>LOADIG DATA</div>;
